module.exports = __webpack_public_path__ + "img/img18.cace2d80.svg";